import React from "react";
import EmptyState from "../shared/EmptyState";
import TemplateForm from "./TemplateForm";
import AddButton from "../shared/AddButton";
import { RelatedTemplatesSectionProps } from "./types";

const RelatedTemplatesSection = ({
    selectedTemplates = [],
    templateList = [],
    state,
    onTemplateChange,
    onTabChange,
    onRemoveTemplate,
    onAddTemplate,
    onSyncTemplateTabs,
    getFilteredOptionsForTemplate
}: RelatedTemplatesSectionProps) => {
    return (
        <>
            {(!selectedTemplates || selectedTemplates.length === 0) && (
                <EmptyState
                    title="Related Curricula Templates & Tabs"
                    label="Template Name"
                    name="templateName"
                    options={templateList.map((template) => ({ 
                        label: template.title, 
                        value: template._id 
                    }))}
                    value={state.templateName || ""}
                    onChange={(name, value) => onTemplateChange(value)}
                />
            )}

            {(selectedTemplates && selectedTemplates.length > 0) &&
                selectedTemplates.map((template, index) => {
                    // Find the full template object from templateList
                    const templateObject = templateList.find(t => t._id === template);
                    return (
                        <TemplateForm
                            key={`${template || "template"}-${index}`}
                            template={template}
                            templateObject={templateObject}
                            index={index}
                            state={state}
                            onTemplateChange={onTemplateChange}
                            onTabChange={onTabChange}
                            onRemoveTemplate={onRemoveTemplate}
                            onSyncTemplateTabs={onSyncTemplateTabs}
                            getFilteredOptionsForTemplate={getFilteredOptionsForTemplate}
                        />
                    );
                })}
            
            <AddButton onAdd={onAddTemplate} label="Add Template" />
        </>
    );
};

export default RelatedTemplatesSection;
